import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/groups',
        component: () => import('@/pages/groups/GroupIndex.vue'),
        props: true,
        children: [
            {
                name: 'groups-index',
                path: '',
                component: () => import('@/components/groups/GroupsView.vue'),
                meta: {
                    title: 'Groups',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) =>
                        gateKeeper.userHasPermission('view all groups') ||
                        gateKeeper.userHasGroupPermission('view all groups'),
                    dataTablePage: true,
                },
                props: true,
            },
            {
                path: ':groupId',
                component: () => import('@/pages/groups/GroupShow.vue'),
                props: true,
                children: [
                    {
                        name: 'group-view',
                        path: '',
                        component: () => import('@/components/groups/GroupView.vue'),
                        meta: {
                            title: 'Group Members',
                            middleware: [GateKeeperMiddleware],
                            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a group'),
                            dataTablePage: true,
                        },
                        props: true,
                    },
                    {
                        name: 'group-courses-view',
                        path: 'courses',
                        component: () => import('@/components/groups/GroupView.vue'),
                        meta: {
                            title: 'Group Courses',
                            middleware: [GateKeeperMiddleware],
                            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a group'),
                            dataTablePage: true,
                        },
                        props: true,
                    },
                    {
                        name: 'group-evaluations-view',
                        path: 'evaluations',
                        component: () => import('@/components/groups/GroupView.vue'),
                        meta: {
                            title: 'Group Evaluations',
                            middleware: [GateKeeperMiddleware],
                            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a group'),
                        },
                        props: true,
                    },
                    {
                        path: 'term-templates',
                        component: () => import('@/pages/term-schedule/TermScheduleIndex.vue'),
                        props: true,
                        children: [
                            {
                                name: 'group-term-templates-index',
                                path: '',
                                component: () => import('@/components/groups/term-templates/TermTemplatesView.vue'),
                                meta: {
                                    title: 'Templates',
                                    middleware: [GateKeeperMiddleware],
                                    ability: ({ gateKeeper }) =>
                                        gateKeeper.userHasPermission('view all term templates'),
                                    dataTablePage: true,
                                },
                                props: true,
                            },
                        ],
                    },
                    {
                        path: 'terms-feature-disabled',
                        component: () => import('@/pages/term-schedule/TermScheduleIndex.vue'),
                        meta: {
                            title: 'Terms',
                            middleware: [GateKeeperMiddleware],
                            ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a term schedule'),
                        },
                        props: true,
                        children: [
                            {
                                name: 'group-term-feature-disabled',
                                path: '',
                                component: () =>
                                    import('@/components/groups/term-schedule/TermScheduleFeatureDisabled.vue'),
                            },
                        ],
                    },
                    {
                        path: 'term-schedules',
                        component: () => import('@/pages/term-schedule/TermScheduleIndex.vue'),
                        props: true,
                        children: [
                            {
                                name: 'group-term-schedules-index',
                                path: '',
                                component: () => import('@/components/groups/term-schedule/TermScheduleView.vue'),
                                props: true,
                                meta: {
                                    title: 'Schedules',
                                    middleware: [GateKeeperMiddleware],
                                    ability: ({ gateKeeper }) =>
                                        gateKeeper.userHasPermission('view all term schedules'),
                                    dataTablePage: true,
                                },
                            },
                            {
                                name: 'term-schedules-preview',
                                path: ':scheduleId/preview',
                                component: () => import('@/components/groups/term-schedule/TermSchedulePreview.vue'),
                                props: true,
                                meta: {
                                    title: 'Schedules',
                                    middleware: [GateKeeperMiddleware],
                                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a term schedule'),
                                },
                            },
                            {
                                name: 'term-schedule-edit',
                                path: ':scheduleId/edit',
                                component: () => import('@/components/groups/term-schedule/TermScheduleEdit.vue'),
                                props: true,
                                meta: {
                                    title: 'Term Schedule Edit',
                                    middleware: [GateKeeperMiddleware],
                                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('edit a term schedule'),
                                },
                            },
                            {
                                name: 'assigned-group-term-schedule-index',
                                path: 'assigned-term-schedules',
                                component: () => import('@/components/groups/term-schedule/AssignedTermsSchedule.vue'),
                                meta: {
                                    title: 'Assigned Schedules',
                                    middleware: [GateKeeperMiddleware],
                                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a term schedule'),
                                },
                                props: true,
                            },
                        ],
                    },
                    // {
                    //     name: 'group-term-schedules-index',
                    //     path: 'term-schedules',
                    //     component: () => import('@/components/groups/GroupView.vue'),
                    //     props: true,
                    //     meta: {
                    //         title: 'Group Term Schedules',
                    //         middleware: [GateKeeperMiddleware],
                    //         ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view all term schedules'),
                    //     },
                    // },
                    // {
                    //     name: 'term-schedules-preview',
                    //     path: 'term-schedules/:scheduleId/preview',
                    //     component: () => import('@/components/groups/GroupView.vue'),
                    //     props: true,
                    //     meta: {
                    //         title: 'Term Schedule Preview',
                    //         middleware: [GateKeeperMiddleware],
                    //         ability: ({ gateKeeper }) => gateKeeper.userHasPermission('view a term schedule'),
                    //     },
                    // },
                ],
            },
        ],
    },
];
